<template>
  <div>
    <PageName :title="pageName" />
    <Form v-model="user" @request="saveUser" class="create__user" ref="user">
      <div class="create__user-form">
        <div class="group-switch mb-20">
          <VSwitch
              v-model="switchValueVip"
              label="VIP"
              @valueChange="switchVip"
          />

          <VSwitch
              v-if="isUser"
              v-model="switchValueNotUpdateDepartment"
              label="Не обновлять подразделение"
              @valueChange="switchNotUpdateDepartment"
          />
        </div>

        <VSelect
          v-if="!isUser"
          placeholder="ФИО"
          name="user"
          :items="usersWithFIO"
          required
          searchSelect
          users
          @change="(seletedUser) => (user = seletedUser) && selectUser()"
        >
          <template slot="item" slot-scope="{ item }">
            <AccountBadge :user="item" />
          </template>
        </VSelect>

        <VInput v-if="isUser" name="surname" required placeholder="Фамилия" />
        <VSelect
          v-if="isUser"
          required
          name="filiation"
          item-text="name"
          placeholder="Филиал"
          :items="filiations"
          :value="user.filiation"
          searchSelect
          filiation
        />
        <VInput v-if="isUser" name="name" required placeholder="Имя" />
        <VSelect
          v-if="isUser"
          required
          name="department"
          item-text="name"
          placeholder="Подразделение"
          :items="departments"
          :value="user.department"
          searchSelect
          department
        />
        <VInput v-if="isUser" name="patronymic" placeholder="Отчество" />
        <VInput
          v-if="isUser"
          name="phone"
          required
          placeholder="Номер служебного мобильного телефона"
        />
        <VInput v-if="isUser" name="birthday" type="date" placeholder="Дата рождения" />
        <VInput name="email" email placeholder="Email" />
        <VInput name="login" required placeholder="Логин" />
        <VSelect
          v-if="isUser"
          required
          placeholder="Пол"
          name="sex"
          item-text="name"
          :items="sexOption"
        />
        <VInput
          v-if="isUser && !isEdit"
          type="password"
          name="newPassword"
          required
          placeholder="Пароль"
          :pattern="pattern"
        >
          <Validation :absolute="false" for="pattern">{{ validationText }}</Validation>
        </VInput>
        <VSelect
          v-if="isUser"
          placeholder="Тип документа"
          name="document"
          item-text="name"
          :items="documentTypes"
          v-model="documentType"
        />
        <VInput
          v-if="isUser && !isEdit"
          type="password"
          name="repeatPassword"
          required
          :sameAs="user.newPassword"
          placeholder="Повторите пароль"
        >
          <Validation :absolute="false" for="sameAs"
            >Пароли не совпадают</Validation
          >
        </VInput>
        <div style="position: relative">
          <VInput
            :required="!!documentType"
            name="document_number"
            placeholder="Номер документа"
            :maskRegex="maskByDocType"
          />
          <!--mask svidetelstvo documentType && documentType.id === 3 ? /[I,V,X]{3}-{1}[А-Я]{2}\s{1}[0-9]{6}$/ : null-->
          <span
            v-tooltip="
              'Номер паспорта РФ должен содержать 10 цифр. <br>' +
              'Номер загранпаспорта РФ должен содержать 9 цифр. <br> '
            "
          >
            <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
              <path fill-rule="evenodd" clip-rule="evenodd" d="M10 20C15.5228 20 20 15.5228 20 10C20 4.47715 15.5228 0 10 0C4.47715 0 0 4.47715 0 10C0 15.5228 4.47715 20 10 20ZM8.13141 7.14286H5.71429C5.71429 4.57143 7.5475 2.85714 10.2857 2.85714C12.8366 2.85714 14.5714 4.49356 14.5714 6.71429C14.5714 8.15632 13.9719 9.20208 12.7143 10C11.528 10.7402 11.0571 11.0671 11.0571 11.99L11.1286 12.8571H8.77143L8.67143 11.9708C8.55548 10.4326 9.19771 9.63584 10.4286 8.85714C11.5792 8.1169 11.8571 7.7512 11.8571 6.85714C11.8571 5.86548 11.1313 5.16439 10 5.16439C8.86867 5.16439 8.18493 6.08537 8.13141 7.14286ZM11.5832 15.7818C11.5832 16.7912 10.9677 17.4161 9.96878 17.4161C8.96982 17.4161 8.34547 16.7912 8.34547 15.7818C8.34547 14.7627 8.96982 14.1379 9.96878 14.1379C10.9677 14.1379 11.5832 14.7627 11.5832 15.7818Z" fill="#B0BBC2"/>
            </svg>
          </span>
        </div>   
        <VSwitch
          v-if="isUser"
          v-model="switchValuePass"
          :label="switchText"
          @valueChange="switchPass"
          style="margin-top: 12px"
        />
        <VSwitch
          v-if="roleId === 1"
          v-model="switchValue"
          :label="switchText"
          style="margin-top: 12px"
        />
      </div>

      <div>
        <Button
          :loading="saveLoading"
          width="228px"
          height="48px"
          :text="isEdit ? 'Сохранить' : 'Создать'"
          class="btn-primary"
        />
        <Button
          @click.native.prevent="$router.go(-1)"
          width="228px"
          height="48px"
          text="Отменить"
          class="btn-secondary"
          style="margin: 12px 0 32px"
        />

        <!-- v-if="isEdit" -->
        <Button
          v-if="false"
          width="228px"
          height="48px"
          text="Отправить пароль"
          class="btn-outline-primary"
          style="margin-bottom: 12px"
          @click.native.prevent="() => {}"
        />
        <Button
          v-if="isEdit"
          width="228px"
          height="48px"
          text="Изменить пароль"
          class="btn-outline-primary"
          @click.native.prevent="openChangePasswordModal"
        />

        <Button
          v-if="!isEdit"
          @click.native.prevent="XMLdialog = true"
          width="228px"
          height="48px"
          text="Загрузить с XML"
          class="btn-outline-primary"
        />
      </div>
    </Form>

    <XMLModal
      v-if="XMLdialog"
      @close="XMLdialog = false"
      url="users/f/import"
    />

    <PasswordModal
      v-if="changePasswordDialog"
      @close="changePasswordDialog = false"
      :request="changePassword"
    />
  </div>
</template>

<script>
import Form from "@/components/Form/Form.vue";
import VInput from "@/components/Form/Vinput/Vinput.vue";
import Validation from "@/components/Form/Validation.vue";
import VSelect from "@/components/Form/VSelect.vue";
import Button from "@/components/Button.vue";
import PageName from "@/components/PageName.vue";
import VSwitch from "@/components/VSwitch.vue";
import AccountBadge from "@/components/AccountBadge.vue";
import PasswordModal from "@/components/Modals/PasswordModal.vue";
import XMLModal from "@/components/Modals/XMLModal.vue";

import { createUser, updateUser, updatePassword } from "@/api/users.js";
import { mapActions, mapState, mapGetters, mapMutations } from "vuex";
import { parseDate, simpleDate } from "@/utils/filters/dateFilters";
import { getSettings } from "@/api/settings";

export default {
  name: "SaveUser",
  components: {
    PageName,
    Form,
    VInput,
    Validation,
    VSelect,
    Button,
    VSwitch,
    AccountBadge,
    PasswordModal,
    XMLModal,
  },
  data() {
    return {
      saveLoading: false,
      switchValue: false,
      switchValuePass: false,
      switchValueVip: false,
      switchPasswordValue: false,
      switchValueNotUpdateDepartment: false,
      user: {},
      documentType: null,
      changePasswordDialog: false,
      XMLdialog: false,
      pattern: "",
      validationText: "",
    };
  },
  mounted() {
    if (this.isEdit) {
      this.user = this.editUser;

      const { birthday, document_validity, department_id, document, sex } = this.editUser;
      this.include(this.filiations, this.editUser?.filiation, this.SET_FILIATIONS)
      this.include(this.departments, this.editUser?.department, this.SET_DEPARTMENTS)

      this.user = {
        ...this.user,
        document: this.documentTypes.find((doc) => doc.id === document?.id),
        document_validity: simpleDate(document_validity),
        department: this.getDepartmentById(department_id) || null,
        sex: this.sexOption.find((option) => option.value === sex),
        birthday: simpleDate(birthday),
      };
      this.switchValuePass = this.user.should_change_password
      this.switchValueVip = this.user.is_vip
      this.switchValueNotUpdateDepartment = this.user.not_update_department
    } else getSettings().then((res) => this.convert(res))

    window.addEventListener("beforeunload", this.prevent);
  },
  beforeDestroy() {
    window.removeEventListener("beforeunload", this.prevent);
  },
  computed: {
    ...mapState("departments", ["departments"]),
    ...mapState("filiations", ["filiations"]),
    ...mapState("users", ["activeUser"]),
    ...mapGetters("departments", ["getDepartmentById"]),
    ...mapGetters("users", ["usersWithFIO"]),
    ...mapState("options", ["documentTypes", "sexOption"]),
    editUser() {
      return this.$route.params.user;
    },
    isEdit() {
      return !!this.editUser;
    },
    isUser() {
      return this.role === "users";
    },
    role() {
      return this.$route.params?.type;
    },
    roleId() {
      switch (this.role) {
        case "users":
          return 2;
        case "admins":
          return 1;
        case "osr-staff":
          return 4;
        case "logisticians":
          return 5;
        default:
          return 2;
      }
    },
    pageName() {
      const mode = this.isEdit ? "Редактировать" : "Создать";
      switch (this.role) {
        case "users":
          return mode + " пользователя";
        case "admins":
          return mode + " администратора";
        case "osr-staff":
          return mode + " сотрудника ОСР";
        case "logisticians":
          return mode + " логиста";
        default:
          return "";
      }
    },
    switchText() {
      switch (this.role) {
        case "admins":
          return "Полные права";
        case "users":
          return "Изменить пароль при входе";
        default:
          return "";
      }
    },
    maskByDocType() {
      switch (this.documentType?.id) {
        case 1:
          return "#### ######";
        case 2:
          return "## #######";
        default:
          return "";
      }
    },
  },
  methods: {
    ...mapActions("users", ["getUsers"]),
    ...mapMutations("users", ["SET_ACTIVE_USER"]),
    ...mapMutations("filiations", ["SET_FILIATIONS"]),
    ...mapMutations("departments", ["SET_DEPARTMENTS"]),
    prevent(event) {
      event.preventDefault();
      event.returnValue = "";
    },
    include(arr, item, state) {
      if (!item && !item?.id) return
      let newArr = [...arr]
      const include = newArr.find(el => el?.id === item.id)
      if (include) return
      newArr.unshift(item)
      state(newArr)
    },
    selectUser() {
      this.user.birthday = simpleDate(this.user.birthday)
    },
    async saveUser(data, passwordData) {
      this.saveLoading = true;
      const {
        id,
        name,
        surname,
        patronymic,
        email,
        login,
        birthday,
        phone,
        department,
        filiation,
        head,
        document,
        document_number,
        document_validity,
        newPassword,
        repeatPassword,
        sex,
        should_change_password,
        is_vip,
        not_update_department
      } = this.isUser ? data : data.user;

      try {
        if (!this.isEdit && this.isUser) {
          const should_change_password = this.switchValuePass 
          const is_vip = this.switchValueVip
          const not_update_department = this.switchValueNotUpdateDepartment

          await createUser(
            name,
            surname,
            patronymic,
            department?.id,
            email,
            login,
            birthday ? parseDate(birthday) : null,
            newPassword,
            repeatPassword,
            phone,
            [2],
            filiation?.id,
            document?.id,
            document_number,
            document_validity ? parseDate(document_validity) : null,
            sex?.value,
            should_change_password,
            is_vip,
            not_update_department
          );
        } else {
          let roles = this.user.roles.map((role) => role.id);

          // Добавление новой роли
          if (!roles.some((id) => id === this.roleId)) {
            roles.push(this.roleId);
          }

          // Добавление дополнительной роли
          if (this.roleId === 1) {
            const extraRoleId = 6;

            if (this.switchValue) {
              extraRoleId && roles.push(extraRoleId);
            } else {
              roles = roles.filter((id) => id !== extraRoleId);
            }
          }

          await updateUser(
            id,
            name,
            surname,
            patronymic,
            department?.id,
            email,
            login,
            birthday ? parseDate(birthday) : null,
            phone,
            roles,
            head,
            filiation?.id,
            document?.id,
            document_number,
            document_validity ? parseDate(document_validity) : null,
            passwordData?.newPassword,
            passwordData?.repeatPassword,
            sex?.value,
            should_change_password,
            is_vip,
            not_update_department
          );
        }

        this.getUsers();
        if (this.isEdit && id === this.activeUser.id) {
          this.SET_ACTIVE_USER({
            ...this.activeUser,
            name: name,
            surname: surname,
            patronymic: patronymic,
            email: email,
            login: login,
            phone: phone,
            department_id: department?.id,
          });
        }

        this.$router.push({
          name: "Users",
          params: { type: this.role, withoutConfrim: true },
        });
      } catch (err) {
        Promise.reject(err);
      }

      this.saveLoading = false;
    },
    openChangePasswordModal() {
      if (this.$refs.user.hasValidationErrors()) return;
      this.changePasswordDialog = true;
    },
    async changePassword(passwordData) {
      try {
        await updatePassword(
          this.user.id,
          passwordData?.newPassword,
          passwordData?.repeatPassword
        );
      } catch (e) {
        if (e?.message?.includes('code 400')) {
          this.$root.popup('Ошибка', 'Новый пароль не должен совпадать с текущим.', 'error');
        } else {
          Promise.reject(e);
        }
      }
    },
    switchPass() {
      this.user.should_change_password = this.switchValuePass
    },
    switchVip() {
      this.user.is_vip = this.switchValueVip
    },
    switchNotUpdateDepartment() {
      this.user.not_update_department = this.switchValueNotUpdateDepartment
    },
    convert (array) {
      // Опции для паттерна проверки пароля
      const { length, uppercase, lowercase, numbers: number, symbols: symbol } = array.reduce(
        (acc, item) => ({
          ...acc,
          [item.name]: item,
        }),
        {}
      );

      this.validationText = "Пароль должен состоять из " + length.value  + " или более символов"
      this.pattern = '^';

      const anyChecked = [uppercase, lowercase, number, symbol].some(({ value }) => value === "1");
      if (anyChecked) {
        this.validationText += " и содержать";
      }

      if (uppercase.value === "1") {
        this.pattern += '(?=.*[A-Z])';
        this.validationText = this.validationText + ", заглавные буквы (A-Z)"
      }
      if (lowercase.value === "1") {
        this.pattern += '(?=.*[a-z])';
        this.validationText = this.validationText + ", строчные буквы (a-z)"
      }
      if (number.value === "1") {
        this.pattern += '(?=.*\\d)';
        this.validationText = this.validationText + ", цифры"
      }
      if (symbol.value === "1") {
        this.pattern += '(?=.*[!@#$%&?*<>_\\-.,:;^=+\\(\\)`~/{}|\\[\\]])';
        this.validationText = this.validationText + ", cимволы (!@#$%&?*<>_-.,:;^=+()`~/{}|\[])" // eslint-disable-line
      }
      this.pattern += '.{' + length.value + ',}.*';
      this.validationText = this.validationText.replace('содержать,', 'содержать');
    },
  },
  beforeRouteLeave(to, from, next) {
    if (to.params.withoutConfrim) {
      next();
    } else {
      this.$root.confrim(
        "Вы точно хотите покинуть эту страницу?",
        () => next(),
        "Да"
      );
    }
  }
};
</script>

<style scoped lang="scss">
.create__user {
  flex-direction: row;
  gap: 15px;
  margin-top: 32px;

  @media screen and (max-width:1500px) {
    margin-top: 24px;
  }

  .create__user-form {
    display: grid;
    grid-template-columns: 1fr 1fr;
    column-gap: 33px;
    padding: 48px 40px;
    row-gap: 12px;
    background: $light-gray;
    border-radius: 4px;
    width: 100%;

    @media screen and (max-width:1500px) {
      padding: 32px 30px;
      column-gap: 18px;
      row-gap: 8px;
    }
  }
}

.group-switch {
  display: flex;
  gap: 30px;
  grid-column: 1 / -1;
  margin-bottom: 20px;
}
</style>
